export const SESSION_STORAGE_KEYS = {
	usageClicks: "usageClicksThisSession",
	usageShown: "usagePopupShownThisSession",
	exitShown: "exitIntentPopupShownThisSession",
	feedbackReminderShown: "feedbackReminderShownThisSession",
} as const;

const getSS = () => (typeof window === "undefined" ? null : window.sessionStorage);

export const ssGet = (key: string): string | null => getSS()?.getItem(key) ?? null;
export const ssSet = (key: string, value: string): void => {
	getSS()?.setItem(key, value);
};
export const ssRemove = (key: string): void => {
	getSS()?.removeItem(key);
};
export const ssClearUsagePopupState = (): void => {
	ssRemove(SESSION_STORAGE_KEYS.usageClicks);
	ssRemove(SESSION_STORAGE_KEYS.usageShown);
	ssRemove(SESSION_STORAGE_KEYS.exitShown);
};
